import { Pipe, PipeTransform } from '@angular/core';
import { SecuritySymbolHelper } from '../../domain/public-api';

@Pipe({
  name: 'tdWbSymbolLookupHighlight'
})
export class SymbolLookupHighlightPipe implements PipeTransform {

  transform(value: string, args?: { value: string }): unknown {
    let highlightedTemplate;
    let symbolMatchingPattern;

    if (args?.value) {
      symbolMatchingPattern = new RegExp(this.escapeRegexp(this.stripeSymbol(args.value)), 'gi');
      highlightedTemplate = '<strong>$&</strong>';
      return (String(value)).replace(symbolMatchingPattern, highlightedTemplate);
    }
    return value;
  }

  private escapeRegexp(queryToEscape: string): string {
    return queryToEscape.replace(/([.?*+^$[\]\\() {}|-])/g, '\\$1');
  }

  private stripeSymbol(q: string): string {
    return SecuritySymbolHelper.isValid(q) ? q.substring(0, q.length - 3) : q;
  }
}
